import { Link } from 'react-router-dom';
import { destinations } from '@/mocks/destinations';

export default function DestinationSection() {
  const featured = destinations.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            热门目的地
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            探索最美亚洲
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3 max-w-xl mx-auto">
            精选东南亚、东亚、南亚最具代表性的旅游目的地，开启您的梦想之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {featured.map((dest) => (
            <Link
              key={dest.id}
              to={`/category/${dest.category}`}
              className="group block cursor-pointer"
            >
              <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
                <div className="relative w-full h-[220px] md:h-[240px] overflow-hidden">
                  <img
                    src={dest.image}
                    alt={`${dest.name} - 亚洲天堂旅游目的地`}
                    title={`${dest.name} - ${dest.nameEn} | 亚洲天堂推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                    <span className="text-white text-sm font-medium bg-black/30 backdrop-blur-sm px-2.5 py-1 rounded-full">
                      {dest.categoryName}
                    </span>
                    <span className="flex items-center gap-1 text-white text-xs">
                      <i className="ri-star-fill text-primary-400 text-xs"></i>
                      {dest.rating}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {dest.name}
                    <span className="text-foreground-400 text-xs ml-2 font-sans">{dest.nameEn}</span>
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm mt-2 line-clamp-2 leading-relaxed">
                    {dest.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {dest.highlights.slice(0, 3).map(h => (
                      <span key={h} className="text-xs bg-background-100 text-foreground-600 px-2 py-1 rounded-md">
                        {h}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/southeast-asia"
            className="inline-flex items-center px-6 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            查看全部目的地
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}